export function initUp(){
    const topButtons = document.querySelectorAll<HTMLAnchorElement>(".top-button");

    topButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault();

            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    });
}